const FormInput = (props) => {
  const handleChange = (e) => {
    let value = e.target.value;
    if (props.numericOnly) {
      // Normalize Persian digits to English digits
      value = value.replace(/[۰-۹]/g, (char) =>
        String.fromCharCode(char.charCodeAt(0) - 1728)
      );

      // Remove any non-numeric characters
      value = value.replace(/[^0-9]/g, "");
    }
    props.onChange(e, value);
  };

  return (
    <div className="form-group mb-3 col-md-12">
      <label htmlFor={props.for} className="form-label">
        <span>{props.name}</span>{" "}
        <span className="text-danger">{props.required ? "*" : ""}</span>
      </label>
      {props.type === "textarea" ? (
        <textarea
          id={props.for}
          className={`form-control iran-sans ${props.styleClasses}`}
          value={props.value}
          type={props.type}
          onChange={props.onChange}
          placeholder={props.placeHolder}
          style={{ height: props.height || "150px", ...props.inputStyle }}
          disabled={props.disabled}
          dir={props.dir}
        />
      ) : (
        <input
          disabled={props.disabled}
          type={props.type || "text"}
          id={props.for}
          className={`form-control iran-sans form-blue ${props.styleClasses}`}
          value={props.value}
          onChange={handleChange}
          placeholder={props.placeHolder}
          style={props.inputStyle}
          dir={props.dir}
          autoComplete={props.autoComplete}
        />
      )}
    </div>
  );
};

export default FormInput;
